var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illus_XSml_96px_-_Complete",
    "data-name": "Illus XSml 96px - Complete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container_4px_Padding",
    "data-name": "Container 4px Padding",
    width: 96,
    height: 96,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161039",
    "data-name": "Path 161039",
    d: "M46.2,7H46A39.012,39.012,0,0,0,30.821,81.937,38.987,38.987,0,0,0,85,46v-.023A38.8,38.8,0,0,0,46.2,7m0-5A44.2,44.2,0,1,1,46,2Z",
    transform: "translate(-2 -2)",
    fill: "#00adbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161040",
    "data-name": "Path 161040",
    d: "M25.2,49.6l-12-11.8a4.2,4.2,0,0,1-.4-5.4,3.8,3.8,0,0,1,6-.4L28,41.2,53.2,16a4,4,0,0,1,5.6,5.6l-28,28a3.8,3.8,0,0,1-5.6,0Z",
    transform: "translate(8.001 11.2)",
    fill: "#09828b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplete);
export default __webpack_public_path__ + "static/media/icon-complete.dfe029e20d3ae380e2a9a1c5f8533f3e.svg";
export { ForwardRef as ReactComponent };